import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\">\r\n<rect y=\"9\" width=\"20\" height=\"2\" fill=\"\" />\r\n<rect x=\"11\" width=\"20\" height=\"2\" transform=\"rotate(90 11 0)\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol